import { tv, type VariantProps } from 'tailwind-variants';

export const iconVariants = tv({
  base: 'fill-inherit text-inherit stroke-inherit',
  variants: {
    size: {
      3: 'size-3',
      4: 'size-4',
      5: 'size-5',
      6: 'size-6',
      7: 'size-7',
      8: 'size-8',
      9: 'size-9',
      10: 'size-10',
    },
  },
  defaultVariants: {
    size: 4,
  },
});

export type IconProps = VariantProps<typeof iconVariants> & {
  className?: string;
  strokeWidth?: number;
};
